import API from "../utils/baseUrl";

/************************************* GET REQUEST ******************************************/

export const getRequest = (endPoint, token, params) => {
  let url;
  if (params !== undefined) {
    var s = "";
    for (var i = 0; i < params.length; i++) {
      s += "/" + params[i];
    }
    url = `${API}/${endPoint}` + s;
  } else {
    url = `${API}/${endPoint}`;
  }
  return fetch(url, {
    method: "GET",
    headers: {
      Accept: "application/json",
      Authorization: `${token}`,
    },
  })
    .then((response) => {
      return response.json();
    })
    .catch((err) => console.log(err));
};

/************************************* POST REQUEST ******************************************/

export const postRequest = (body) => {
  let url;
  url = `${API}/${body.endPoint}`;
  return fetch(url, {
    method: "POST",
    headers: {
      Authorization: `${body.token}`,
    },
    body: body.formData,
  })
    .then((response) => {
      return response.json();
    })
    .catch((err) => {
      console.log(err);
    });
};

/************************************* PUT REQUEST ******************************************/

export const putRequest = (body) => {
  let url;
  if (body.params !== undefined) {
    var s = "";
    for (var i = 0; i < body.params.length; i++) {
      s += "/" + body.params[i];
    }
    url = `${API}/${body.endPoint}` + s;
  } else {
    url = `${API}/${body.endPoint}`;
  }
  return fetch(url, {
    method: "PUT",
    headers: {
      Authorization: `${body.token}`,
    },
    body: body.formData,
  })
    .then((response) => {
      return response.json();
    })
    .catch((err) => {
      console.log(err);
    });
};
